import { Editor } from '@tinymce/tinymce-react'

export default function RichTextEditor({ onInit, defaultValue, dir = 'rtl' }) {
  return (
    <Editor
      tinymceScriptSrc="/assets/js/tinymce/tinymce.min.js"
      onInit={(evt, editor) => onInit(evt, editor)}
      initialValue={defaultValue}
      // onChange={(x, y) => {
      //   console.log(x, y)
      // }}
      init={{
        license_key: 'gpl',
        directionality: dir,
        content_style:
          "body { font-family: 'Cairo', sans-serif; color: #1e6f92; font-size:18px; }",
        content_css:
          'https://fonts.googleapis.com/css2?family=Cairo:wght@200;300;400;500;600;700;800;900;1000&display=swap',
        plugins:
          'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
        editimage_cors_hosts: ['picsum.photos'],
        menubar: false,
        toolbar:
          'ltr rtl | blocks fontsize | bold italic underline strikethrough superscript subscript | align numlist bullist | table charmap | outdent indent | forecolor backcolor removeformat ',
        autosave_ask_before_unload: true,
        image_advtab: true,
        importcss_append: true,
        height: 256,
        image_caption: true,
        quickbars_selection_toolbar:
          'bold italic underline strikethrough superscript subscript | h2 h3 quickimage quicktable',
        toolbar_mode: 'wrap',
        contextmenu: 'link image table',
      }}
    />
  )
}
